import Vue from 'vue'

export default {
  getSiteConfigurationByUrl (hostname) {
    return Vue.prototype.$http.get(`/site_configurations/find_by_url_site?url_site=${hostname}`)
  }
}
